<div id="mainComponentContainer">
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div v-show="!loading">
                    <data-table :headings="suspendedCustomerHeadings" :data="suspendedCustomers" :hasActions="true"
                                :pagingDetails="pagingDetails"
                                :stateChanged="filterStateChanged"
                                @pagingUpdated="onPagingUpdated"
                                @actionClicked="onCustomerActionClicked" @filterSearchClicked="onFilterSearchClicked">
                        
                        <template #filter>
                            <div class="p-3">
                                <div class="input-group pb-4">
                                    <input type="text" class="form-control" placeholder="Search" aria-label="Search" aria-describedby="basic-addon1" v-model="filter.searchQuery">
                                    <div class="input-group-append">
                                        <span class="input-group-text" id="basic-addon1">
                                            <i class="fas fa-search"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </data-table>
                </div>
                <loading-spinner :showSpinner="loading"></loading-spinner>
            </div>
        </div>
    </div>

    <!-- Reinstate Company Confirmation Modal -->
    <confirm-delete-modal
        :elementId="reinstateModal.modalId"
        :message="reinstateModal.message"
        :showModal="reinstateModal.showModal"
        :loading="reinstateModal.loading"
        :modalTitle="reinstateModal.title"
        @deleteConfirmed="onReinstateConfirmed"></confirm-delete-modal>
</div>
